import Cookies from 'js-cookie';
import { useEffect } from 'react';

export default function useConsentGA() {
  useEffect(() => {
    const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

    function loadGA() {
      if (!GA_ID || document.getElementById('gtag')) return;

      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      script.async = true;
      script.id = 'gtag';
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', GA_ID, {
        anonymize_ip: false,
        send_page_view: true,
      });
    }

    if (Cookies.get('cookieConsent') === 'accepted') loadGA();
    window.addEventListener('cookieAccepted', loadGA);

    return () => window.removeEventListener('cookieAccepted', loadGA);
  }, []);
}
